import { render, staticRenderFns } from "./AccountGarageContainer.vue?vue&type=template&id=8009b122&"
import script from "./AccountGarageContainer.vue?vue&type=script&lang=js&"
export * from "./AccountGarageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports